import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { RoleEnum } from 'src/app/modules/shared/models';

@Component({
  selector: 'role-selection',
  templateUrl: './role-selection.component.html',
  styleUrls: ['./role-selection.component.scss']
})
export class RoleSelectionComponent implements OnInit {

  public roles !: Array<RoleEnum>;
  public title !: string;
  public onClose = new Subject<RoleEnum>();

  public userRoles : Record<RoleEnum | string, string> = {
    [RoleEnum.ADMIN] : "fa fa-unlock",
    [RoleEnum.BUYER] : "fa fa-credit-card",
    [RoleEnum.PO_BUYER] : "fa fa-credit-card",
    [RoleEnum.QES_APPROVER] : "fa fa-thumbs-up",
    [RoleEnum.REPORTING_MANAGER] : "fa fa-users",
    [RoleEnum.REQUESTER] : "fa fa-user",
    [RoleEnum.SUPPLIER] : "fa fa-external-link",
    [RoleEnum.EHS_MANAGER] : "fa fa-users",
    [RoleEnum.FACTORY_PROCUREMENT]: "fa fa-user-secret"
  };

  constructor(public bsModalRef : BsModalRef) { }

  ngOnInit(): void {
  }

  /******** Method to be used for closing modal **********/
  public closeModal(data : RoleEnum) {
    this.onClose.next(data);
    this.bsModalRef.hide();
  }

  public onModalClose() : void {
    this.bsModalRef.hide()
  }

}
